module.exports = __webpack_public_path__ + "media/images/question_mark_icon-fb010361.svg";